import type { FaireProductEntity } from "../../entity_types/product";

export const p_9mo4stxz3d: FaireProductEntity = {
  token: "p_9mo4stxz3d",
  type: "product",
  name: "Silver Strength Fulvic Acid & Trace Mineral Supplement",
  brandToken: "b_4ce3l13q1j",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7b2ea436eb0f86f64e05e99a766fca2dec66f7b51c9f572edef389ad1db95c84.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dab1d26ba4ccafdaa1abe364bf7818222ac180b2a1172758031eeb735c60f3f.jpeg",
    "https://cdn.faire.com/fastly/96bb90c90a9b7202f5a174578c8990b65b9359a65286731606f98086d4a0f676.jpeg",
    "https://cdn.faire.com/fastly/20924c15f4db68f5db50c9a7c454aaf04c0ed2c811aa4a3e6d4950dd11f43814.jpeg",
    "https://cdn.faire.com/fastly/30419c9d2d1c0089dfa35614aa236f38236e754dbddc81260642a200d20e00d8.png",
    "https://cdn.faire.com/fastly/e2a87d97683aa7ca1f5ff94907c2ee779dfa6195236199ddfbda11530198f73e.png",
    "https://cdn.faire.com/fastly/33bd8e13c04f5ee46e9f6220157fa571bcff997fa3fbd12ddad4e28c203a4941.jpeg",
    "https://cdn.faire.com/fastly/a3dae70b3b4c4e7c3ef7c15631b7670d7c5662b2abfe25bcdf6ed3c6f3153ade.jpeg",
    "https://cdn.faire.com/fastly/3a4fcc53d877714f87add143914183c5bd052bd0ff11e577abe88b60cd9dbc85.png",
  ],
  priceDollars: 32,
  description:
    "Silver Strength Fulvic Acid & Trace Mineral Supplement is an innovative formulation where silver ions are intricately chelated with Liquid Light, our trace minerals and Fulvic Acid complex. Fulvic Acid acts as a carrier, facilitating the transport of silver ions into cells to fortify the immune system and provide robust support against various pathogens.\n\nSilver Strength is a potent antimicrobial and antibacterial solution, adept at combating bacterial, viral, fungal, and parasitic threats. The ionic silver and trace minerals work synergistically, interrupting metabolic reactions and inhibiting cellular replication. This powerful blend offers essential trace minerals crucial for oxygen transport, growth, development, repair, bone health, cartilage formation, and the maintenance of cellular membranes.\n\nWith 50 parts per million of silver ions per serving, Silver Strength is your natural defense powerhouse, delivering unparalleled support for immune health and overall well-being.",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:05.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
